import React from "react";
import Image from "next/image";
import cn from "classnames";

const CarouselCard = ({
  imgUrl,
  imgAlt,
  longQuote,
  quote,
  name,
  title,
  blurDataURL,
  current,
  onClick,
}) => (
  <div
    className={cn("keen-slider__slide", current && "current")}
    onClick={onClick}
  >
    <div className="copy">
      <h5 className={cn("heading heading--xs", longQuote && "long-quote")}>
        &ldquo;{quote}&rdquo;
      </h5>
      <div>
        <p>— {name}</p>
        <p>{title}</p>
      </div>
    </div>

    {imgUrl && (
      <div className="image-wrapper">
        <Image
          src={imgUrl}
          width={440}
          height={440}
          style={{ objectFit: "cover" }}
          alt={imgAlt}
          className="image"
          blurDataURL={blurDataURL}
          placeholder="blur"
        />
      </div>
    )}
  </div>
);

export default CarouselCard;
